import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGIN } from 'store';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert, Row, Col, Container, InputGroup, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import LoginService from '../../services/login';
import * as logo from "../../images/logo-dark.png";
import * as logoWhite from "../../images/logo-branco-scan.png";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { ProfileType, CompanyType } from '../../helpers/Enum';
import './style.scss';
import Storage from 'helpers/storage';

const formatUser = (data, fiscal_years, companyId = null) => {
  let companies = data.companies;

  let profile = data.profiles[0];
  let company = companyId ? companies.filter(c => c.id === companyId)[0] : (companies.length > 1 ? null : companies[0])

  if(company && company.ranking){
    company['ranking_position'] = company.ranking.position;
  }

  let result = {
    ...data,
    currentProfile: profile,
    currentCompanyType: company?company.company_type_id:null,
    fiscal_year: fiscal_years[fiscal_years.length - 1],
    fiscal_years: fiscal_years,
    currentCompany: company && company.company_type_id === CompanyType().Resale ? company : null
  };
  if(company && company.company_type_id === CompanyType().Resale){
    localStorage.setItem('currentCompany', JSON.stringify(company));
  }

  return result;
}

const loadSession = async (data, fiscal_years, token) => {
  
  let user = formatUser(data, fiscal_years);
  await LoginService.registerLog({
    user_id: user.id, 
    company_id: user.currentProfile.profile_type_id == ProfileType.Resale ? user.companies[0].id : 1,
  }, token)
  localStorage.setItem('user', JSON.stringify(user));
}

export default function(){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState({ show: false, error: false });

  const [user, setUser] = useState(null);
  const [fiscalYears, setFiscalYears] = useState([]);
  const [token, setToken] = useState(!!Storage.get("token"));
  const [company, setCompany] = useState(null);
  const [isLoad, setLoad] = useState(false);
  
  var hidden = true;
  const minWidth = 940;
  const isMobile = window.innerWidth <= minWidth;

  const [isLogged, setLogged] = useState(localStorage.getItem('user') ? true : false);
  const { t } = useTranslation();

  const authenticateData = (email, password) => {
    setLoad(true);
    setMessage({ ...{ show: false, error: true } });
    let response = LoginService.login(email, password);
    response.then(({data}) => {
      if (data.message && data.message == 'Unauthorized') {
        setMessage({ ...{ show: true, error: true } });
        setLoad(false);
      } else {
        //localStorage.setItem('data_log', JSON.stringify(data.data))
        Storage.set("token",data.data.access_token)
        // localStorage.setItem('fiscal_years', JSON.stringify(data.data.fiscal_year))
        window.location.reload(true);
        // window.location.href = "/";
      }
      // setToken(data.data.access_token);
    }).catch((error) => {
      setLoad(false);
      if (error.response)
        if (error.response.status === 404 || error.response.status === 401) {
          setMessage({ ...{ show: true, error: true, message: error.response.data.message } });
        } else {
          console.error(error.response);
        }
    });
  }

  useEffect(() => {
    const con = async () => {
      if (user && token && fiscalYears.length > 0) {
        await loadSession(user, fiscalYears, token);
        setLogged(true);  
      }
    }
    con()
  }, [user, fiscalYears, token]);

  if (token) {
    window.location.href = "/";
  }

  return (
    <>
      <div className={isMobile?"bg-scansource pl-3":''} style={{height:'100vh'}}>
      <Row className={isMobile?"bg-scansource p-3":''} style={{height:'100vh'}}>
        <Col md="5" className={(isMobile?'':'p-5')+" col-login"} style={{background:'white'}}>
          <div style={{textAlign: "-webkit-center"}}>
            <div className="scan-logo">
              <span>
                <img src={logo} alt="ScanSource" width={!isMobile?"250":'200'} />
              </span>
            </div>
          </div>
          <div className="login-text">
            <h5 className="login-h5">Log in.</h5>
            <span className="login-span">Insira seus dados de acesso</span>
          </div>
          <Container className="pl-5 pr-5">
            {message.show ? (
              <Alert variant={message.error ? "danger" : "success"}>
                {message.message}
                {/* {message.error ?
                <>
                  <p>Olá!</p>
                  <p>
                    O novo portal ainda não está disponível. 
                    Mas fique tranquilo, em breve você receberá por e-mail todas as instruções para acesso.
                  </p>
                  <p>
                    Em caso de dúvidas, fique à vontade para entrar em contato conosco pelo 
                    e-mail <a style={{color: 'blue'}} href='mailto:elitepass@scansource.com'>elitepass@scansource.com</a>.
                  </p>
                </>
                : "E-mail enviado"} */}
              </Alert>
            ) : ''}
          </Container>
          <Form className="login-form"
            onSubmit={e => {
              e.preventDefault();
              authenticateData(email, password);
            }}
          >
            <Form.Group>
              <Form.Label className="form-label">{t('label:email')}</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <MailOutlineIcon className="icon-input" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="email"
                  onChange={e => setEmail(e.target.value)}
                  className="input-size"
                  required
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <Form.Label className="form-label">{t('label:password')}</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>
                    <LockOutlinedIcon className="icon-input" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="password"
                  onChange={e => setPassword(e.target.value)}
                  className="input-size"
                  required
                />
              </InputGroup>
            </Form.Group>
            <Form.Group>
              <Form.Check className="form-label" type="checkbox" label='Lembrar-me' />
            </Form.Group>
            {isLoad ? (
              <p className="text-center mt-2">
                <Spinner animation="border" style={{ color: '#e05c17' }} />
              </p>
            ) : (
                <Button block type="submit" className="login-btn">
                  Acessar
                </Button>
              )}
            <p className="text-center mt-2">
              <Link to="/forgotten-password" className="forgot-password">
                Esqueceu a senha?
              </Link>
            </p>
          </Form>
        </Col>
        {!isMobile?(
          <Col md="7" className="bg-scansource">
            <div className="scan-logo-white">
              <span>
                {/* <img src={logoWhite} alt="ScanSource" width="250" /> */}
              </span>
            </div>
            {/* <div className="scan-site mt-3">
              <span>
                www.scansource.com.br
              </span>
            </div> */}
          </Col>
        ):''}
      </Row>
      </div>
    </>
  );
};

const mapStateToProps = state => { };

const mapDispatchToProps = dispatch => ({
  login: (email, password) =>
    dispatch({
      type: ASYNC_USER_LOGIN,
      payload: { email, password }
    })
});

export {
  formatUser,
  loadSession
}